/**
 * Bulk order page layout styled components (viewport-fill flex chain).
 * Docs: impl/src/browser/bulkOrder/README.md
 */
import styled from 'styled-components'
import { Box, Col, Row } from '../components'

export const BulkOrderHeader = styled(Box.Header)`
  padding: 0;
  align-items: stretch;
  border-bottom: none;
`

export const BulkOrderBox = styled(Box)`
  flex: 1;
  min-height: 0;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
`

export const BulkOrderBoxContent = styled(Box.Content)`
  padding: 0;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const BulkOrderLayout = styled(Row)`
  margin-bottom: 0;
  align-items: stretch;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`

export const BulkOrderSidebarCol = styled(Col)`
  height: 100%;
  min-height: 0;
`

export const BulkOrderMainCol = styled(Col)`
  height: 100%;
  min-height: 0;
`

export const BulkOrderState = styled.div`
  padding: 2rem 5rem 3rem;
`
